import {
    Gutters,
    MainButton,
    MenuButton,
    TextInputField,
    Typography,
    VerticalExpander,
} from '@eventr/common-storybook'
import { Box, Radio, Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { NavigationView } from '../../layout/NavigationView'
import {
    useDuplicateContext,
    useDuplicateStore,
} from '../state/duplicate.context'

export const SelectItineraryPage = () => {
    const duplicateContext = useDuplicateStore()

    const { overrideName, selectedItin, orgItins } = useDuplicateContext(
        useShallow((s) => ({
            selectedItin: s.selectedItin,
            overrideName: s.overrideName,
            orgItins: s.orgItins,
        }))
    )

    const footer = (
        <Box display={'grid'} padding={'16px'}>
            <MainButton
                id="nextButton"
                style={{ width: '100%' }}
                text={i18n.t('general.next')}
                onClick={() => {
                    window.pushPath('/guestdup/datetimerangeselect')
                }}
                disabled={
                    selectedItin.id === -1 &&
                    (!overrideName || overrideName === '')
                }
            />
        </Box>
    )

    return (
        <NavigationView
            navigationBarTitle={i18n.t('guest.duplicateItinerary')}
            navigationBarSubtitle={i18n.t('guest.selectItinSubTitle')}
            backButtonAction={() => {
                window.goBack()
            }}
            usePageTransition
            footer={footer}
        >
            <Gutters>
                <Stack spacing={'24px'}>
                    <Stack>
                        <Typography variant="mobileH3">
                            {i18n.t('guest.selectItinerary')}
                        </Typography>
                        <Typography>
                            {i18n.t('guest.selectItineraryExplanaition')}
                        </Typography>
                    </Stack>
                    <Stack alignItems="center" spacing="8px">
                        {orgItins?.map((itin: any, index: number) => {
                            return (
                                <MenuButton
                                    id={itin.id}
                                    key={index}
                                    onClick={() => {
                                        duplicateContext
                                            .getState()
                                            .setSelectedItin(itin)
                                    }}
                                >
                                    <Stack
                                        flexDirection="row"
                                        gap="16px"
                                        alignItems="center"
                                    >
                                        <Radio
                                            style={{ padding: '0px' }}
                                            checked={
                                                duplicateContext.getState()
                                                    .selectedItin.id === itin.id
                                            }
                                            onClick={() => {}}
                                        />
                                        <Typography variant="bodyRegular">
                                            {itin.itinerary_name}
                                        </Typography>
                                    </Stack>
                                </MenuButton>
                            )
                        })}
                        <MenuButton
                            id="create-new-itinerary-radio"
                            onClick={() => {
                                duplicateContext.getState().setSelectedItin({
                                    id: -1,
                                    end_time: 0,
                                    start_time: 0,
                                    itinerary_name: '',
                                    last_updated: 0,
                                    itinerary_version: '',
                                    itinerary_endpoint: '',
                                    tags: [],
                                })
                            }}
                        >
                            <Stack
                                flexDirection="row"
                                gap="16px"
                                alignItems="center"
                            >
                                <Radio
                                    style={{ padding: '0px' }}
                                    checked={selectedItin.id === -1}
                                />
                                <Typography variant="bodyRegular">
                                    {i18n.t('account.create-new-itinerary')}
                                </Typography>
                            </Stack>
                        </MenuButton>
                        <Box display={'grid'} width={'100%'}>
                            <VerticalExpander open={selectedItin.id === -1}>
                                <Stack
                                    display={'grid'}
                                    width={'100%'}
                                    style={{ marginTop: '16px' }}
                                    spacing={'16px'}
                                >
                                    <Stack>
                                        <Typography variant="bodyBold">
                                            {i18n.t(
                                                'guest.itinerary-information'
                                            )}
                                        </Typography>
                                        <Typography>
                                            {i18n.t(
                                                'guest.itinerary-info-more'
                                            )}
                                        </Typography>
                                    </Stack>
                                    {/* spacing dont work because TextInputField has  marginTop: '8px' thats not good... */}
                                    <TextInputField
                                        value={overrideName}
                                        style={{ marginTop: '16px' }}
                                        fieldLabel={i18n.t(
                                            'guest.itinerary-name'
                                        )}
                                        required
                                        id="SelectItineraryPage.itineraryName"
                                        onChange={(e) => {
                                            duplicateContext
                                                .getState()
                                                .setOverrideName(e.target.value)
                                        }}
                                    />
                                </Stack>
                            </VerticalExpander>
                        </Box>
                    </Stack>
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
